import { ReactElement, FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isDispatched } from "@ctra/utils";

import { Enterprise, EnterpriseAppState, User, UserEntity } from "@ctra/api";

interface UserProviderProps {
  children: (user: Partial<UserEntity>, meta: { isLoading: boolean }) => ReactElement | null;
}

/**
 * Fetch the current user object if it is not yet present in the store
 * @param children
 * @constructor
 * @deprecated in favor of UserContext
 */
export const UserProvider: FC<UserProviderProps> = ({ children }) => {
  const dispatch = useDispatch();

  /**
   * Get the currently logged in username from the auth state
   */
  const username = useSelector<EnterpriseAppState, UserEntity["username"]>(Enterprise.entities.getUsername);

  /**
   * Attempt to get the user object
   */
  const user = useSelector<EnterpriseAppState, UserEntity | undefined>((state) =>
    Enterprise.entities.getUser(state, { username: username })
  );

  /**
   * Tell whether the fetching action has been dispatched
   */
  const dispatched = useSelector<EnterpriseAppState, boolean>((state) =>
    isDispatched(state, User.types.FETCH_USER)
  );

  useEffect(() => {
    if (!(dispatched || user)) {
      dispatch(User.actions.fetchUser.start(username as string));
    }
  }, [dispatch, dispatched, user, username]);

  return children(user || { username }, { isLoading: !user });
};
